// extracted by mini-css-extract-plugin
export var highlightOriginal = "_65-0";
export var highlightSuggested = "_65-1";